var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactosNa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3571 7.5C20.3571 6.2568 19.7927 5.06451 18.7881 4.18544C17.7834 3.30636 16.4208 2.8125 15 2.8125C13.5792 2.8125 12.2166 3.30636 11.2119 4.18544C10.2073 5.06451 9.64286 6.2568 9.64286 7.5C9.64286 8.7432 10.2073 9.93549 11.2119 10.8146C12.2166 11.6936 13.5792 12.1875 15 12.1875C16.4208 12.1875 17.7834 11.6936 18.7881 10.8146C19.7927 9.93549 20.3571 8.7432 20.3571 7.5ZM6.42857 7.5C6.42857 5.51088 7.33163 3.60322 8.93908 2.1967C10.5465 0.790176 12.7267 0 15 0C17.2733 0 19.4535 0.790176 21.0609 2.1967C22.6684 3.60322 23.5714 5.51088 23.5714 7.5C23.5714 9.48912 22.6684 11.3968 21.0609 12.8033C19.4535 14.2098 17.2733 15 15 15C12.7267 15 10.5465 14.2098 8.93908 12.8033C7.33163 11.3968 6.42857 9.48912 6.42857 7.5ZM3.30134 27.1875H26.6987C26.1027 23.4785 22.4598 20.625 18.0603 20.625H11.9397C7.54018 20.625 3.89732 23.4785 3.30134 27.1875ZM0 28.2598C0 22.4883 5.34375 17.8125 11.9397 17.8125H18.0603C24.6562 17.8125 30 22.4883 30 28.2598C30 29.2207 29.1094 30 28.0112 30H1.98884C0.890625 30 0 29.2207 0 28.2598Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactosNa);
export default __webpack_public_path__ + "static/media/ContactosNA.32e0baf19afd5aa2dcdf8cff97471ce3.svg";
export { ForwardRef as ReactComponent };